import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type ProfileTabState = 'profile' | 'orders' | 'security' | 'settings';

interface SettingsStore {
    viewMode: 'grid' | 'table';
    profileActiveTab: ProfileTabState;
    navigateProfileTab: (tab: ProfileTabState) => void;
    setViewMode: (mode: 'grid' | 'table') => void;
}

export const useSettingsStore = create<SettingsStore>()(
    persist(
        (set) => ({
            viewMode: 'grid',
            profileActiveTab: 'profile',
            setViewMode: (mode) => set({ viewMode: mode }),
            navigateProfileTab: (tab) =>
                set({
                    profileActiveTab: tab,
                }),
        }),
        {
            name: 'bd_settings',
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
